import * as React from 'react';

// Placeholder
const PregnancyHistoryRowData = (): React.JSX.Element => <></>;

export default PregnancyHistoryRowData;
